var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlusreact(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 11H13V4C13 3.448 12.552 3 12 3C11.448 3 11 3.448 11 4V11H4C3.448 11 3 11.448 3 12C3 12.552 3.448 13 4 13H11V20C11 20.552 11.448 21 12 21C12.552 21 13 20.552 13 20V13H20C20.552 13 21 12.552 21 12C21 11.448 20.552 11 20 11Z",
    fill: "currentColor"
  })));
}
export default SvgPlusreact;